import { render, staticRenderFns } from "./zhuanzhang.vue?vue&type=template&id=2909f2f9&scoped=true"
import script from "./zhuanzhang.vue?vue&type=script&lang=js"
export * from "./zhuanzhang.vue?vue&type=script&lang=js"
import style0 from "./zhuanzhang.vue?vue&type=style&index=0&id=2909f2f9&prod&lang=scss&scoped=true"
import style1 from "./zhuanzhang.vue?vue&type=style&index=1&id=2909f2f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2909f2f9",
  null
  
)

export default component.exports